<template>
  <div class="login-form">
    <Login/>
  </div>
</template>

<script>
import Login from "./Login";

export default {
  components: {
    Login,
  },
  data() {
    return {
      collapsed: false,
      open: null,
    };
  },
  methods: {
    login() {
      console.log("Login clicked");
      this.open = "login";
    },
    register() {
      console.log("Register clicked");
      this.open = "register";
    },
    home() {
      console.log("home");
      this.open = null;
    },
  },
};
</script>
<style scoped>

</style>
